import { BrowserModule } from '@angular/platform-browser';
import { NgModule,CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { HomeComponent } from './components/home/home.component';
import { SharedModule } from 'src/app/shared/components/shared.modules';
import { GalleryModule } from 'ng-gallery';

// import { ProductStatusPipe } from './Shared/pipe/product-status.pipe';
// import { ProfileComponent } from './profile/profile.component';

let components = [
  HomeComponent,
]

@NgModule({
  declarations:components,
  imports: [
    BrowserModule,
    FormsModule,
    HttpClientModule,
    SharedModule,
    // GalleryModule.withConfig({ loadingMode: 'indeterminate'})
    GalleryModule
  ],
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: components
})
export class HomeModule { }
